module.exports = __webpack_public_path__ + "img/play.e670df17.svg";